import {DeserializedRecord} from "./Helpers";

type DeserializeCtx = {
  cache: Map<string, DeserializedRecord>;
  building: Set<string>;
};

let currentCtx: DeserializeCtx | null = null;

const runInCtx = <T>(fn: (ctx: DeserializeCtx) => T): T => {
  if (currentCtx) return fn(currentCtx);
  currentCtx = {cache: new Map(), building: new Set()};
  try { return fn(currentCtx); } finally { currentCtx = null; }
};

const keyOf = (t: string, id: string) => `${t}:${id}`;

export {
  runInCtx,
  keyOf,
  DeserializeCtx
};
